import React from 'react';
import { Box, Typography, Card, CardContent, Alert } from '@mui/material';

const NetCentersManagement = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" fontWeight="bold" gutterBottom>
        Net Centers Management
      </Typography>
      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Alert severity="info">
            Net centers (franchisee) management module - To be implemented for Phase 2.
          </Alert>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NetCentersManagement;

